// extracted by mini-css-extract-plugin
module.exports = {"nav-link":"MenuItem_nav-link__2LUXW","active":"MenuItem_active__1_lwo","icon":"MenuItem_icon__3IogV","text":"MenuItem_text__3n66R"};